<template>
  <div class="app">
    <siteNavigation v-if="user.email" />
    <imageBanner v-if="user.email" title="Pricing Calculator" />
    <router-view/>
  </div>
</template>

<script>
import userStore from '@/store/userStore';
import siteNavigation from '@/components/navigation.vue';
import imageBanner from '@/components/banner.vue';

export default {
  name: 'home',
  components: {
    siteNavigation,
    imageBanner,
  },
  data() {
    return {
      user: userStore.user,
    };
  },
};
</script>

<style lang="scss">
// =============================================================================
// BRANDING
// =============================================================================
$bmi-primary:           #009FE3;
$bmi-secondary:         #0079AD;


// =============================================================================
// FONT/ICON IMPORTS
// =============================================================================
@import url('https://fonts.googleapis.com/css?family=Nunito:300,400,700&font-display=swap');
@import url('https://unpkg.com/ionicons@4.4.6/dist/css/ionicons.min.css');


// =============================================================================
// BULMA VARIABLE OVERIDES
// =============================================================================
// Global
$family-sans-serif:     'Nunito', 'avenir', Helvetica, sans-serif;
$body-background-color: #F2F6FA;
// Colours
$primary:               $bmi-primary;
$info:                  $bmi-primary;
$link:                  $bmi-secondary;


// =============================================================================
// FRAMEWORKS
// =============================================================================
// Bulma
@import '~bulma/bulma.sass';
// Notifications
@import '~vue-awesome-notifications/dist/styles/style.scss';


// =============================================================================
// BULMA EXTENSIONS
// =============================================================================
// Steps overides
$steps-active-color:      $cyan;
$steps-completed-color:   #20778E;
// Extension
@import '~bulma-steps/dist/css/bulma-steps.sass';
</style>
